import { type UseQueryResult, useQuery } from 'react-query';
import {
  ParticipantCashTransferServiceService,
  // eslint-disable-next-line camelcase
  type Wealthlane_AwardSettlementService_Dtos_ParticipantCashBalance_ParticipantBalanceDataDto,
} from '../../services/wealthlane-award-settlement-services';

const useGetCurrentBalanceForParticipants = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  id?: string,
  awardType?: string
): UseQueryResult<
  // eslint-disable-next-line camelcase
  | Wealthlane_AwardSettlementService_Dtos_ParticipantCashBalance_ParticipantBalanceDataDto
  | undefined,
  unknown
> => {
  const currentBalanceForParticipants = useQuery(['getCurrentBalanceForParticipants'], async () => {
    return await handleRequest(
      ParticipantCashTransferServiceService.getApiAwardSettlementApiAppParticipantCashTransferServiceCurrentBalanceForParticipant()
    );
  });

  return currentBalanceForParticipants;
};

export default useGetCurrentBalanceForParticipants;
